export const AUTHENTICATION_ATTACHMENT = 'platform';
export const USER_VERIFICATION = 'preferred';
export const BIOMETRIC_CHALLENGE_FORM = 'biometricChallengeForm';
